import {Injectable} from '@angular/core';
import {ISummary} from '../../../summary/model/summary';
import {Driver} from '../../../summary/model/driver';
import {ChartDataSet} from '../../components/chart/chart.component';

@Injectable({
    providedIn: 'root'
  })
  
  export class ChartService {
    summaryBarChartData!: ChartDataSet;
    public static barColors = ['#0289C7', '#00593F', '#6BC4ED','#F5A9AA', '#EDBF6B'];

    public createBarChartOptions(data: ISummary[], driver: Driver[] = []) {
        let summaryChartLabels: string[] = [];
        let summaryChartData: number[] = [];
        let summaryChartDataSet: any[] = [];
        if (driver) {
          summaryChartLabels = driver.map(item => item.driverName);
        }
        data.forEach((obj: ISummary, index) => {
          summaryChartData = driver.map((_) => 0);
          obj.drivers.forEach(childObj => {
          let driverIndex = driver.findIndex(x => x.driverId == childObj.driverId);
          summaryChartData[driverIndex] = childObj.timeInMins ? childObj.timeInMins : childObj.value!;
        });
    
        summaryChartDataSet.push({
          data: summaryChartData,
          label: obj.name,
          backgroundColor: ChartService.barColors[index % ChartService.barColors.length]
          });
        });

        this.summaryBarChartData = {
          labels: summaryChartLabels,
          datasets: summaryChartDataSet
        };
        return this.summaryBarChartData
    }
    
  }